import React from 'react'

export const GuildHighResShieldIcon: React.FC<{ size?: number; className?: string }> = ({
  size = 72,
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 68 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.36842 2H62.6316C64.4919 2 66 3.53665 66 5.44203V32.6667C66 47.4301 54.8754 63.9705 36.1965 70.3119C34.7734 70.7951 33.2266 70.7951 31.8035 70.3119C13.1246 63.9705 2 47.4301 2 32.6667V5.44319C2 3.53781 3.50809 2 5.36842 2Z"
        fill="url(#paint0_linear_3919_292)"
      />
      <path
        d="M5.36842 2H62.6316C64.4919 2 66 3.53665 66 5.44203V32.6667C66 47.4301 54.8754 63.9705 36.1965 70.3119C34.7734 70.7951 33.2266 70.7951 31.8035 70.3119C13.1246 63.9705 2 47.4301 2 32.6667V5.44319C2 3.53781 3.50809 2 5.36842 2Z"
        fill="url(#paint1_linear_3919_292)"
        fillOpacity="0.51"
      />
      <path
        d="M5.36842 2H62.6316C64.4919 2 66 3.53665 66 5.44203V32.6667C66 47.4301 54.8754 63.9705 36.1965 70.3119C34.7734 70.7951 33.2266 70.7951 31.8035 70.3119C13.1246 63.9705 2 47.4301 2 32.6667V5.44319C2 3.53781 3.50809 2 5.36842 2Z"
        fill="url(#paint2_linear_3919_292)"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.36842 0.5H62.6316C65.329 0.5 67.5 2.69465 67.5 5.39215V32.2222C67.5 48.0765 54.9822 65.6141 34.4089 71.4432C34.1416 71.5189 33.8584 71.5189 33.5911 71.4432C13.0178 65.6141 0.5 48.0765 0.5 32.2222V5.39329C0.5 2.69645 2.67034 0.5 5.36842 0.5ZM34 70C54 64.3333 66 47.3333 66 32.2222V5.39215C66 3.51438 64.4919 2 62.6316 2H5.36842C3.50809 2 2 3.51552 2 5.39329V32.2222C2 47.3333 14 64.3333 34 70Z"
        fill="url(#paint3_linear_3919_292)"
      />
      <path
        d="M4.46309 35.7398C4.95482 51.8699 20.1985 62.7967 32 68C28.7371 43.2535 28.7266 28.9943 32 4C32 4 5.44655 4.00064 4.46309 4C3.49369 3.99937 4.32645 31.2659 4.45782 35.5673L4.46309 35.7398Z"
        fill="url(#paint4_linear_3919_292)"
        fillOpacity="0.45"
      />
      <path
        d="M34.1815 29.3985H45.1755C45.3857 29.415 45.5959 29.5137 45.6929 29.6783C45.8384 29.8265 45.9354 30.0404 45.9354 30.2708V44.7378C45.9354 44.853 45.9031 44.9847 45.8546 45.0999C45.8061 45.2151 45.7252 45.3139 45.6282 45.3962C42.2653 47.1737 38.5144 48.0624 34.715 47.9966C25.9844 47.7826 19 40.8865 19 31.999C19 23.1279 25.9844 15.8861 34.715 16.0014C38.4012 16.1166 42.4755 17.7624 45.4665 20.5274C45.5635 20.5933 45.6444 20.692 45.6929 20.7908C45.7576 20.8895 45.7899 21.0047 45.7899 21.1199C45.7899 21.2351 45.7737 21.3504 45.7252 21.4656C45.6767 21.5643 45.612 21.6631 45.5312 21.7454L42.1198 25.3827C41.942 25.4979 41.7318 25.5637 41.5216 25.5637C41.3114 25.5637 41.1013 25.4979 40.9234 25.3827C39.2581 23.7204 37.3018 23.1114 35.1839 23.062C29.8647 22.9468 26.5665 27.0943 26.5665 31.9496C26.5665 36.8542 29.8647 40.8207 35.2324 40.9359C36.5581 40.9688 37.8677 40.7713 39.1288 40.3269V35.8173C38.1588 35.768 35.0224 35.768 34.1492 35.768C34.036 35.768 33.939 35.7515 33.8258 35.7186C33.7288 35.6692 33.6318 35.6198 33.5509 35.5375C33.4701 35.4552 33.4054 35.3565 33.3569 35.2577C33.3084 35.159 33.2923 35.0438 33.2923 34.9286V30.2215C33.2923 30.1062 33.3084 29.991 33.3569 29.8923C33.4054 29.7935 33.4701 29.6948 33.5509 29.6125C33.6318 29.5302 33.7288 29.4644 33.842 29.4315C33.9551 29.3985 34.0683 29.3821 34.1815 29.3985Z"
        fill="url(#paint5_linear_3919_292)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3569 35.2577C33.3084 35.159 33.2923 35.0438 33.2923 34.9286V30.2215C33.2923 30.1063 33.3084 29.991 33.3569 29.8923C33.4054 29.7935 33.4701 29.6948 33.5509 29.6125C33.6318 29.5302 33.7288 29.4644 33.842 29.4315C33.9551 29.3985 34.0683 29.3821 34.1815 29.3985H45.1755C45.3857 29.415 45.5959 29.5138 45.6929 29.6783C45.8384 29.8265 45.9354 30.0404 45.9354 30.2708V44.7378C45.9354 44.853 45.9031 44.9847 45.8546 45.0999C45.8061 45.2151 45.7252 45.3139 45.6282 45.3962C42.2653 47.1737 38.5144 48.0624 34.715 47.9966C25.9844 47.7826 19 40.8865 19 31.999C19 23.1279 25.9844 15.8862 34.715 16.0014C38.4012 16.1166 42.4755 17.7624 45.4665 20.5274C45.5635 20.5933 45.6444 20.692 45.6929 20.7908C45.7576 20.8895 45.7899 21.0047 45.7899 21.1199C45.7899 21.2351 45.7737 21.3504 45.7252 21.4656C45.6767 21.5643 45.612 21.6631 45.5312 21.7454L42.1198 25.3827C41.942 25.4979 41.7318 25.5637 41.5216 25.5637C41.3114 25.5637 41.1012 25.4979 40.9234 25.3827C39.2581 23.7204 37.3018 23.1114 35.1839 23.062C29.8647 22.9468 26.5665 27.0944 26.5665 31.9496C26.5665 36.8542 29.8647 40.8207 35.2324 40.9359C36.5581 40.9688 37.8677 40.7713 39.1288 40.327V35.8173C38.1588 35.768 35.0224 35.768 34.1492 35.768C34.036 35.768 33.939 35.7515 33.8258 35.7186C33.7288 35.6692 33.6318 35.6198 33.5509 35.5375C33.4701 35.4553 33.4054 35.3565 33.3569 35.2577ZM38.1288 36.7899C36.8191 36.7682 34.8337 36.768 34.1492 36.768C33.9239 36.768 33.7317 36.7327 33.5465 36.6788L33.4561 36.6525L33.3722 36.6098C33.3673 36.6073 33.3618 36.6045 33.3557 36.6015C33.2643 36.5555 33.0369 36.4412 32.8376 36.2383C32.6666 36.0643 32.5443 35.8716 32.4593 35.6986C32.3173 35.4095 32.2923 35.1236 32.2923 34.9286V30.2215C32.2923 30.0264 32.3173 29.7406 32.4593 29.4514C32.5443 29.2785 32.6666 29.0858 32.8376 28.9117M38.1288 36.7899V39.5924C37.1939 39.848 36.2322 39.9604 35.2572 39.9362L35.2538 39.9361C32.8246 39.884 30.9213 38.9678 29.6211 37.5603C28.3141 36.1452 27.5665 34.178 27.5665 31.9496C27.5665 27.5464 30.5065 23.9614 35.1614 24.0618C37.0828 24.1067 38.7724 24.6485 40.2169 26.0904L40.2914 26.1648L40.3797 26.222C40.7089 26.4352 41.1062 26.5637 41.5216 26.5637C41.937 26.5637 42.3344 26.4352 42.6635 26.222L42.7658 26.1557L46.2542 22.4363C46.4202 22.2648 46.5394 22.0761 46.6228 21.9064L46.6356 21.8803L46.6469 21.8536C46.7597 21.5855 46.7899 21.3314 46.7899 21.1199C46.7899 20.839 46.7163 20.552 46.5626 20.2957C46.4566 20.0989 46.3016 19.9064 46.1029 19.754C42.9451 16.8546 38.6638 15.1243 34.7462 15.0018L34.7372 15.0016L34.7282 15.0014C25.4057 14.8784 18 22.6056 18 31.999C18 41.4441 25.4323 48.7694 34.6905 48.9963L34.6977 48.9964C38.6646 49.0652 42.5824 48.1372 46.0955 46.2803L46.1919 46.2293L46.2751 46.1587C46.4607 46.0013 46.6527 45.7812 46.7762 45.4879C46.8618 45.2847 46.9354 45.0195 46.9354 44.7378V30.2708C46.9354 29.8054 46.7581 29.3782 46.4825 29.0602C46.1554 28.6037 45.6337 28.4314 45.2536 28.4016L45.2146 28.3985H34.2365C33.9705 28.3748 33.7378 28.4203 33.5627 28.4712C33.2499 28.5622 33.01 28.7362 32.8376 28.9117"
        fill="url(#paint6_linear_3919_292)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3919_292"
          x1="12"
          y1="6.56618"
          x2="37.1164"
          y2="66.1741"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0439639" stopColor="#C57B46" />
          <stop offset="0.333786" stopColor="#DBA775" />
          <stop offset="0.721059" stopColor="#CC7A3D" />
          <stop offset="0.928708" stopColor="#A25A38" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3919_292"
          x1="2.5"
          y1="-1.55147"
          x2="11.2169"
          y2="20.1777"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3919_292"
          x1="40"
          y1="66.9412"
          x2="25.6612"
          y2="36.6604"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3919_292"
          x1="32.5221"
          y1="-1.47222"
          x2="41.4041"
          y2="63.1161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE8CC" />
          <stop offset="0.127299" stopColor="#DDAA85" />
          <stop offset="1" stopColor="#5F3116" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3919_292"
          x1="10.3639"
          y1="7.12195"
          x2="32.102"
          y2="65.6709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.42" />
          <stop offset="1" stopColor="white" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3919_292"
          x1="23.253"
          y1="16.5316"
          x2="40.2648"
          y2="47.8972"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0416579" stopColor="#141313" />
          <stop offset="0.594408" stopColor="#4A2B27" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3919_292"
          x1="35.188"
          y1="51.125"
          x2="24.6628"
          y2="12.8153"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.127299" stopColor="#DDAA85" stopOpacity="0.4" />
          <stop offset="1" stopColor="#5F3116" />
        </linearGradient>
      </defs>
    </svg>
  )
}
